import { call, put } from 'redux-saga/effects'
import { PayloadAction } from '@reduxjs/toolkit'
import apiMiddleware from 'services/api_middleware'
import app_config from 'config/app_config'

import { onOpenNotification } from 'redux/notification/reducer'
import {
	IDeleteTeamMemberRequest,
} from '../types'
import { deleteTeamMemberFailure, deleteTeamMemberSuccess } from '../reducer'

export function* deleteTeamMemberSaga({
	payload,
}: PayloadAction<IDeleteTeamMemberRequest>) {
	try {
		const { message }: { message: string } = yield call(apiMiddleware, {
			url: app_config.services.deleteTeamMember,
			data: payload,
			method: 'POST',
		})

		yield put(
			onOpenNotification({
				message,
				notificationType: 'success',
			})
		)

		yield put(deleteTeamMemberSuccess())
	} catch (e) {
		const error = e as { message: string }

		yield put(
			onOpenNotification({
				message: error.message,
				notificationType: 'error',
			})
		)

		yield put(deleteTeamMemberFailure())
	}
}
